import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ColorLogo from "../assets/login/ColorLogo.png";
import logo1 from "../assets/header/HABD.png";
import logo2 from "../assets/login/DMW_Patiala.png";
import logo3 from "../assets/login/NoviusLogo.png"; // Watermark logo

// Helper functions for formatting (same as in LogSearch component)
const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  
  // Format time as "12:38 PM"
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert to 12-hour format
  
  return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
};

// Calculate browsing time from login and logout time
const calculateBrowsingTime = (loginTime, logoutTime) => {
  if (!logoutTime) {
    return "Active";
  }
  
  const login = new Date(loginTime);
  const logout = new Date(logoutTime);
  const diffMs = logout - login;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHrs = Math.floor(diffMins / 60);
  const remainingMins = diffMins % 60;
  
  return `${diffHrs}h ${remainingMins}m`;
};

const DownloadUserLogsPDF = async (
  selectedSite,
  selectedSiteName,
  userLogs,
  timePeriod,
  setIsLoading
) => {
  try {
    setIsLoading(true);
    
    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.username || "Guest";
    const downloadDate = new Date();
    const formattedDateTime = formatDate(downloadDate); // Using the same format as table
    
    // Calculate date range for time period
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(toDate.getDate() - parseInt(timePeriod));
    
    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);
    
    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const logoWidth = 18;
    const logoHeight = 15;
    
    const addHeader = () => {
      doc.setTextColor(0, 0, 0);
      if (ColorLogo) {
        const logoX = 10;
        const logoY = 5;
        const logoW = 35;
        const logoH = logoHeight;
        doc.addImage(ColorLogo, "PNG", logoX, logoY, logoW, logoH);
        doc.link(logoX, logoY, logoW, logoH, {
          url: "https://noviusrailtech.com/",
        });
      }
      if (logo2) {
        doc.addImage(
          logo2,
          "PNG",
          pageWidth - logoWidth - 10,
          5,
          logoWidth,
          logoHeight
        );
      }
      const titleText =
        "NOVIUS HABD (Lite) - NOVIUS HOT AXLE BOX DETECTION SYSTEM (LITE MODEL)";
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      const textWidth = doc.getTextWidth(titleText);
      const centerX = pageWidth / 2;
      const offsetX = 20;
      const textX = centerX - textWidth / 2 + offsetX;
      if (logo1) {
        const logo1X = textX - logoWidth - 4;
        doc.addImage(logo1, "PNG", logo1X, 5, logoWidth, logoHeight);
      }
      doc.text(titleText, textX, 15);
      doc.setDrawColor(200, 200, 200);
      doc.line(10, 22, pageWidth - 10, 22);
    };
    
    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const pageStr = `Page ${i} of ${pageCount}`;
        doc.text(
          pageStr,
          pageWidth - 14 - doc.getTextWidth(pageStr),
          pageHeight - 10
        );
        doc.setTextColor(80);
        doc.setFont("helvetica", "italic");
        const footerText = `Downloaded by: ${userName} | Download Time: ${formattedDateTime}`;
        doc.text(footerText, 14, pageHeight - 10);
      }
    };
    
    const addWatermark = () => {
      if (logo3) {
        const watermarkWidth = 150;
        const watermarkHeight = 100;
        const watermarkX = (pageWidth - watermarkWidth) / 2;
        const watermarkY = (pageHeight - watermarkHeight) / 2;
        doc.saveGraphicsState();
        doc.setGState(new doc.GState({ opacity: 0.08 })); // Subtle watermark
        doc.addImage(logo3, "PNG", watermarkX, watermarkY, watermarkWidth, watermarkHeight);
        doc.restoreGraphicsState();
      }
    };
    
    // Add initial header
    addHeader();
    let lastTableY = 40;
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    
    // Update time period to show date range
    doc.text(`Time Period: ${formattedFromDate} - ${formattedToDate}`, 14, lastTableY);
    lastTableY += 10;
    
    doc.text(`Generated on: ${formattedDateTime}`, 14, lastTableY);
    lastTableY += 15;
    
    doc.text("User Logs", 14, lastTableY);
    lastTableY += 10;
    
    if (userLogs?.length > 0) {
      const logColumns = [
        { content: "Sr. No.", styles: { halign: "center" } },
        { content: "User", styles: { halign: "center" } },
        { content: "Email", styles: { halign: "center" } },
        { content: "Login Time", styles: { halign: "center" } },
        { content: "Logout Time", styles: { halign: "center" } },
        { content: "Browsing Time", styles: { halign: "center" } },
        { content: "Status", styles: { halign: "center" } },
        { content: "IP Address", styles: { halign: "center" } },
      ];
      
      const logBody = userLogs.map((log, index) => [
        { content: index + 1 },
        { content: log.username || "N/A" },
        { content: log.email || "N/A" },
        { content: log.LoginTime ? formatDate(log.LoginTime) : "N/A" },
        { content: log.LogoutTime ? formatDate(log.LogoutTime) : "Still Active" },
        { content: calculateBrowsingTime(log.LoginTime, log.LogoutTime) },
        { content: log.IsActive ? "Active" : "Inactive" },
        { content: log.IPAddress || "N/A" },
      ]);
      
      // Calculate total width available for columns
      const totalWidth = pageWidth - 20; // Subtract left and right margins (10 each)
      
      autoTable(doc, {
        startY: lastTableY,
        margin: { left: 10, right: 10, top: 25 }, // Added top margin to ensure gap
        head: [logColumns],
        body: logBody,
        theme: "grid",
        styles: {
          fontSize: 9,
          cellPadding: 3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          valign: "middle",
          overflow: "linebreak", // Handle text overflow
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: "bold",
        },
        columnStyles: {
          0: { cellWidth: totalWidth * 0.05, halign: "center" }, // Sr. No.
          1: { cellWidth: totalWidth * 0.10, halign: "center" }, // User
          2: { cellWidth: totalWidth * 0.15, halign: "center" }, // Email
          3: { cellWidth: totalWidth * 0.15, halign: "center" }, // Login Time
          4: { cellWidth: totalWidth * 0.15, halign: "center" }, // Logout Time
          5: { cellWidth: totalWidth * 0.10, halign: "center" }, // Browsing Time
          6: { cellWidth: totalWidth * 0.10, halign: "center" }, // Status
          7: { cellWidth: totalWidth * 0.20, halign: "center" }, // IP Address
        },
        // Prevent row splitting across pages
        rowPageBreak: 'avoid',
        // Ensure that if a row doesn't fit, it moves entirely to the next page
        pageBreak: 'auto',
        // Set minimum row height to ensure consistent appearance
        minRowHeight: 10,
        didDrawPage: (data) => {
          // Add header and watermark to every page
          addHeader();
          addWatermark();
          
          // Set the startY for the next table to be right after the header
          if (data.pageNumber > 1) {
            data.table.startY = 40; // Consistent gap between header and table on all pages
          }
        },
        didDrawTable: (data) => {
          lastTableY = data.table.finalY + 10;
        },
        // Hook to handle row height calculation
        willDrawCell: (data) => {
          // Calculate the required height for the cell content
          const cellContent = data.cell.raw;
          if (typeof cellContent === 'string') {
            const textLines = doc.splitTextToSize(cellContent, data.cell.width - 6);
            const requiredHeight = textLines.length * 4 + 6; // Approximate height calculation
            
            // Ensure the row height is sufficient
            if (data.row.height < requiredHeight) {
              data.row.height = requiredHeight;
            }
          }
        },
      });
    } else {
      doc.text("No user logs data available", 14, lastTableY);
      addWatermark();
    }
    
    addFooter();
    doc.save(`User_Logs_${new Date().toISOString().slice(0, 10)}.pdf`);
  } catch (error) {
    console.error("Error generating User Logs PDF:", error);
    throw error;
  } finally {
    setIsLoading(false);
  }
};

export default DownloadUserLogsPDF;